const formatDate = (dateStr, typeMonth = "long") => {
  if (!dateStr) return null;
  return new Intl.DateTimeFormat("es-Es", {
    year: "numeric",
    month: typeMonth,
    day: "2-digit",
  }).format(new Date(dateStr));
};

export default formatDate;
